var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBubbleWhite = function SvgBubbleWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 130.24,
    height: 82.63,
    viewBox: "0 0 130.24 82.63",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h130.24v82.63H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M106.23 66.7c18.36-7.28 26.89-20.54 23.15-36.8C123.64 4.91 96.98.08 65.12 0 17.81-.12 1.62 11.99.05 38.08c-1.38 22.91 25.2 34.7 68.53 34.71 6.04.02 12.07-.37 18.06-1.17l-.03.01c4.07-.54 6.13 1.3 7.09 2.99 2.18 3.81 5.79 6.59 10.03 7.73 1.27.37 2.15.35 2.45.07.15-.14.51-.49-.69-1.86-1.25-1.42-6.72-10.32.74-13.86"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBubbleWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bubble-white.f7bff175dbc2377f0c02497a514a89e3.svg";